/* eslint-disable jsx-a11y/no-static-element-interactions */

import {
  buyAtCardKingdom,
  buyAtTCGPlayer,
  clearClipboard,
  closeMobileImage,
  copyClipboard,
  exportToArchidekt,
  exportToMoxfield,
  toggleDecklist,
  updatePrices,
} from "../store/clipboard";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import ClipboardItems from "./ClipboardItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import empty from "../assets/empty.png";
import memoize from "memoize-one";
import styles from "../styles/Clipboard.module.scss";
import useDarkMode from "use-dark-mode";
import { useEffect } from "react";

const Clipboard = () => {
  const darkMode = useDarkMode(false);
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.clipboard.cards);
  const commander = useSelector((state) => state.clipboard.commander);
  const isLoadingRecs = useSelector((state) => state.clipboard.isLoadingRecs);
  const isOpen = useSelector((state) => state.clipboard.isOpen);
  const mobileImageIsOpen = useSelector((state) => state.clipboard.mobileImageIsOpen);
  const price = useSelector((state) => state.clipboard.price);
  const recs = useSelector((state) => state.clipboard.recs);
  const viewerImage = useSelector((state) => state.clipboard.viewerImage);

  const organizeCards = memoize((cards) => {
    const lists = {
      Artifact: { cards: [], i: 3, plural: "Artifacts" },
      Creature: { cards: [], i: 0, plural: "Creatures" },
      Enchantment: { cards: [], i: 4, plural: "Enchantments" },
      Instant: { cards: [], i: 1, plural: "Instants" },
      Land: { cards: [], i: 6, plural: "Lands" },
      Planeswalker: { cards: [], i: 5, plural: "Planeswalkers" },
      Sorcery: { cards: [], i: 2, plural: "Sorceries" },
    };
    Object.values(cards).map((card) => lists[card.primary_type]?.cards.push(card));
    return lists;
  });

  const organizedLists = organizeCards(cards);

  useEffect(() => {
    dispatch(updatePrices());
  }, []);

  return (
    <div className={classNames(styles.decklist, { [styles.dark]: darkMode.value, [styles.open]: isOpen }, "shadow")}>
      <div className={styles.decklistToggle} onClick={() => dispatch(toggleDecklist())}>
        <div className={styles.decklistToggleArrowMobile}>
          <FontAwesomeIcon icon="paperclip" />
        </div>
      </div>
      <div className={styles.decklistContentWrapper}>
        <div className={styles.decklistMainContentWrapper}>
          <div className={classNames(styles.decklistCardsContainer, styles.decklistBorder)}>
            <ClipboardItems commander={commander} lists={organizedLists} recs={recs} />
            {isLoadingRecs && (
              <>
                <div className={styles.decklistSectionHeader}>Recs</div>
                <div className={styles.recsLoader}>
                  <div />
                  <div />
                  <div />
                </div>
              </>
            )}
          </div>
          <div className={styles.decklistButtonsWrapper}>
            <div className={styles.buyButtonsWrapper}>
              <Button onClick={() => dispatch(buyAtCardKingdom())} variant="outline-secondary">
                Card Kingdom: ${price.cardkingdom?.toFixed(2)}
              </Button>
              <Button onClick={() => dispatch(buyAtTCGPlayer())} variant="outline-secondary">
                TCGplayer: ${price.tcgplayer?.toFixed(2)}
              </Button>
              <Button onClick={() => dispatch(exportToArchidekt())} variant="outline-secondary">
                Export to Archidekt
              </Button>
              <Button onClick={() => dispatch(exportToMoxfield())} variant="outline-secondary">
                Export to Moxfield
              </Button>
            </div>
            <div className={styles.actionButtonsWrapper}>
              <Button onClick={() => dispatch(copyClipboard())} variant="outline-secondary">
                Copy
              </Button>
              <Button onClick={() => dispatch(clearClipboard())} variant="outline-secondary">
                Clear
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.decklistImageContentWrapper}>
          <div className={styles.decklistImageViewer}>
            <img
              alt="Preview"
              className={classNames(styles.decklistImage, {
                empty: viewerImage === "",
              })}
              src={viewerImage || empty}
            />
          </div>
        </div>
      </div>
      <div
        className={classNames(styles.mobileImageViewer, {
          open: mobileImageIsOpen,
        })}
      >
        <div className={styles.mobileImageWrapper}>
          <img alt="Preview" className={styles.mobileImage} src={viewerImage || empty} />
        </div>

        <FontAwesomeIcon
          className={styles.mobileImageCloseButton}
          icon="times"
          onClick={() => dispatch(closeMobileImage())}
        />
      </div>
      <div className={styles.decklistEmptyMessage}>
        Click the add button on any card to start building your decklist
      </div>
    </div>
  );
};

export default Clipboard;
